export const DATA_LIMIT_MESSAGE =
  "We couldn't load all of your data due to your volume for this set of filters and compares.";

export const ERROR_WHITELIST = [
  'Your analytics request spans our upgrade uniques cutoff date.'
];
